/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledSlider = styled.div`
  .dyc-captcha-slider {
    position: relative;
    height: 32px;

    &-main {
      line-height: 32px;

      &.dragging {
        .dyc-captcha-slider-handle {
          border-color: #1283d5;
          background: #1283d5;
          color: #fff;
        }
      }

      &.checked-failed {
        .dyc-captcha-slider-track {
          background: #fee7e7;
          border-color: #f85858 !important;
        }

        .dyc-captcha-slider-handle {
          background: #f85858;
          color: #fff;
          border: #f85858;
        }
      }

      &.checked-success {
        .dyc-captcha-slider-track {
          background: #e2f5ec;
          border-color: #3dbd7d !important;
        }

        .dyc-captcha-slider-handle {
          background: #3dbd7d;
          color: #fff;
          border: #3dbd7d;
        }
      }
    }

    &-images {
      position: absolute;
      bottom: 32px;
      left: 0;
      width: 100%;
      display: none;
      z-index: 1004;
      opacity: 0;
      transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
      transform: translateY(0);
      padding-bottom: 10px;

      &.entering {
        display: block;
        opacity: 0;
        transform: translateY(8px);
      }

      &.entered {
        display: block;
        opacity: 1;
        transform: translateY(0);
      }

      &.exiting {
        display: block;
        opacity: 0;
        transform: translateY(8px);
      }

      .images-wrapper {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.22);
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.22);
        border-radius: 4px;
        padding: 6px;

        > div {
          position: relative;
        }
      }

      img.big {
        width: 100%;
      }

      img.small {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
      }
    }

    &-handle {
      background: #ffffff;
      box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.11);
      border: 1px solid #e9e9e9;
      border-radius: 4px;
      height: 32px;
      width: 32px;
      position: absolute;
      left: 0;
      text-align: center;
      cursor: pointer;

      &:hover {
        background: #1283d5;
        color: #fff;
        border-color: #1283d5;
      }
    }

    &-track {
      height: 32px;
      background: #e1eff9;
      border-radius: 4px;
      width: 0;
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid transparent;
    }

    &-tips {
      height: 32px;
      background: #f7f9fa;
      border: 1px solid #e9e9e9;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      color: #999;
    }
  }
`;

export const StyledHeader = styled.div`
  background: #f4f9ff;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: relative;
  img {
    width: 38px;
    margin-right: 10px;
  }
  > svg {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  > span {
    font-size: 14px;
    font-weight: bold;
  }

  .modal-close {
    width: 48px;
    height: 48px;
    outline: 0;
    border: 0;
    cursor: pointer;
    background: transparent;
    padding: 0;
    line-height: 1;
    position: absolute;
    top: 0;
    right: 0;
  }
`;

export const StyledIcon = styled.svg`
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
`;
